import { SuggestedMarker } from './suggested-marker'
import { WorkoutPopup } from '../programmes/programme-workout-popup'
import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { SuggestedImage } from 'src/component/lets-get-moving/suggeste-image'
import { SuggestedInfoContainer } from 'src/component/lets-get-moving/suggested-info-container'
import { SuggestedSectionTitle } from 'src/component/lets-get-moving/suggested-section-title'
import { SuggestedSkeleton } from 'src/component/lets-get-moving/suggested-skeleton'
import { SuggestedTitle } from 'src/component/lets-get-moving/suggested-title'
import { Badge } from 'src/component/ui/badge/badge'
import { CompletedBadge } from 'src/component/ui/completed-badge'
import { useSessionContext } from 'src/context/session-context'
import { Workout } from 'src/dao/core-dao'
import { useSuggestedWorkouts } from 'src/hook/use-suggested-workouts'

export const SuggestedWorkouts = (): React.ReactElement => {
  const { completedWorkoutIds } = useSessionContext()

  const { suggestedWorkouts, isLoading } = useSuggestedWorkouts()
  const [selectedWorkout, setSelectedWorkout] = useState<Workout | undefined>(undefined)

  if ((!suggestedWorkouts || suggestedWorkouts.length === 0) && !isLoading) return <></>

  return (
    <>
      <div className="mb-8 lg:mb-10">
        <SuggestedSectionTitle>SUGGESTED WORKOUTS</SuggestedSectionTitle>
      </div>
      {isLoading ? (
        <Row>
          {Array.from({ length: 3 }).map((_, index) => (
            <Col xs={12} lg={4} key={index} className="mb-4">
              <SuggestedSkeleton />
            </Col>
          ))}
        </Row>
      ) : (
        <Row>
          {suggestedWorkouts?.map((workout) => (
            <Col xs={12} lg={4} key={workout.id} className="mb-4">
              <button
                className="rounded-md overflow-hidden cursor-pointer w-full text-left"
                data-nextstep="suggested-workouts"
                onClick={() => setSelectedWorkout(workout)}
                type="button"
                aria-label={`View details for ${workout?.title} workout`}
              >
                <SuggestedMarker className="bg-secondary" />
                <div className="relative">
                  <SuggestedImage fileId={workout?.imagePublicFileId} />
                  <SuggestedInfoContainer>
                    <div className="flex justify-between items-start gap-2 w-full">
                      <p className="text-ivory font-roboto-condensed-medium text-lg lg:text-xl capitalize flex-1 min-w-0">
                        {workout.trainer?.firstName}
                      </p>
                      {completedWorkoutIds.has(workout.id) ? (
                        <div className="shrink-0 self-end">
                          <CompletedBadge />
                        </div>
                      ) : null}
                    </div>
                    <div>
                      <SuggestedTitle>{workout?.title}</SuggestedTitle>
                      <div className="flex">
                        <Badge>{`${workout.duration} min`}</Badge>
                      </div>
                    </div>
                  </SuggestedInfoContainer>
                </div>
              </button>
            </Col>
          ))}
        </Row>
      )}
      <WorkoutPopup
        setOnClose={() => setSelectedWorkout(undefined)}
        selectedWorkout={selectedWorkout}
        startWorkoutLink={selectedWorkout ? `/workouts/${selectedWorkout?.id}` : undefined}
      />
    </>
  )
}
